import { apiClient } from "./apiClient";

export const formEditorTypeApi = {
    load: () => apiClient.get(`form-editor-type`)
}